/**
 * 混雑データ取得API
 */
import { apiGet } from './client';

/**
 * 混雑詳細データを取得
 * @param {string} location - 場所
 * @param {Object} options - オプション
 * @param {string} options.targetDate - 対象日
 * @param {number} options.weeksCount - 週数
 * @param {AbortSignal} options.signal - キャンセル用のシグナル
 * @returns {Promise<Object>} 混雑詳細データ
 */
export async function getCongestionDetail(location, options = {}) {
  return apiGet(`/congestion-data/${location}`, {
    target_date: options.targetDate,
    weeks_count: options.weeksCount || 3,
  }, { signal: options.signal });
}

/**
 * 混雑サマリーデータを取得
 * @param {string} location - 場所
 * @param {Object} options - オプション
 * @param {string} options.targetDate - 対象日
 * @param {number} options.weeksCount - 週数
 * @param {AbortSignal} options.signal - キャンセル用のシグナル
 * @returns {Promise<Object>} 混雑サマリーデータ
 */
export async function getCongestionSummary(location, options = {}) {
  return apiGet(`/congestion-data/${location}/summary`, {
    target_date: options.targetDate,
    weeks_count: options.weeksCount || 3,
  }, { signal: options.signal });
}
